import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import BaseChat from "./components/base";
import WebApp from '@twa-dev/sdk';
import './eula.css'; // CSS defined below

const App = () => {
  const [agreed, setAgreed] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const initWebApp = async () => {
      WebApp.ready();
      WebApp.expand();
    };

    initWebApp();

    // Check if user has already accepted the EULA
    const accepted = localStorage.getItem("eulaAccepted");
    if (accepted === "true") {
      setAgreed(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("eulaAccepted", "true");
    setAgreed(true);
  };

  if (!agreed) {
    return (
      <div className="eula-overlay">
        <div className="eula-modal">
          <h2>End-User License Agreement</h2>
          <div className="eula-text">
  <p><strong>AVACHAT</strong> is an AI-powered virtual assistant designed to provide automated responses based on user input. It is classified as a <strong>Limited Risk AI system</strong> under the EU Artificial Intelligence Act.</p>

  <p>You acknowledge and agree that:</p>
  <ul style={{ textAlign: "left", paddingLeft: "1.2rem" }}>
    <li>AVACHAT is an automated system, not a human.</li>
    <li>Responses are generated by AI and may not always be accurate, complete, or suitable for decision-making in sensitive contexts.</li>
    <li>You should not rely on AVACHAT for medical, legal, financial, or safety-critical advice. Always consult a qualified professional.</li>
    <li>You are responsible for ensuring that your use of AVACHAT complies with the EU AI Act, GDPR, and any applicable local regulations.</li>
    <li>Solidus AI Tech does not accept liability for any downstream legal or regulatory obligations triggered by your use of AVACHAT in regulated or high-risk environments.</li>
  </ul>

  <p>By continuing, you agree to use AVACHAT responsibly and understand its limitations as an AI system.</p>
  <p>For more information, please refer to our <a href="https://aitech.io/aitech-eu-ai-act-compliant/" target="_blank" rel="noopener noreferrer">EU AI Compliance Guide</a>.</p>
</div>

          <label className="checkbox-container">
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
            I agree to the Terms and Conditions
          </label>
          <button
            className="eula-button"
            onClick={handleAccept}
            disabled={!checked}
          >
            Submit
          </button>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<BaseChat />} />
      </Routes>
    </Router>
  );
};

export default App;
